import { useState } from 'react';
import { emojiInString } from '../utils/emoji-checker';

const useInputValidation = (input: string) => {
  const [inputError, setInputError] = useState<boolean>(false);

  const validateInput = (): boolean => {
    if (emojiInString(input)) {
      setInputError(true);
      setTimeout(() => {
        setInputError(false);
      }, 4000);
      throw new Error('Emojis are not allowed in notes.');
    }
    return true;
  };

  return { inputError, validateInput };
};

export default useInputValidation;
